import Vue from 'vue'
import toastStore from '@/stores/toast-store.js'
import i18n from '../i18n'
import ConfirmationModal from '@/vcs/_shared/modals/confirmation-modal/cmp.vue'
import store from '@/stores/Store'
import { PublicClientApplication } from '@azure/msal-browser'

const ERROR_CODES = {
  'cp:1': 'no_boxes_to_self_assignment',
  'cp:4': 'no_membership',
  'b:1': 'cannot_open_because_problem_with_opening_box',
  'b:2': 'cannot_unassign_locker_on_demand',
  'b:3': 'box_member_was_not_found',
  'sp:1': 'above_assignment_limit',
  'pass:1': 'you_cannot_use_previous_password',
}

const registerMsalInstance = () => {
  const msalConfig = {
    auth: {
      clientId: '9b0a867f-75b2-43a1-b290-cfeed07f4430',
      redirectUri: 'https://zabka.pwa.collectomate.io/aad-sso-sign-in',
      authority: 'https://login.microsoftonline.com/153ec1e0-e0e7-4a31-82a0-d1f594ce8825',
    },
  }
  return new PublicClientApplication(msalConfig)
}

Vue.prototype.$dev = process.env.VUE_APP_ENV == 'development'
Vue.prototype.$production = process.env.VUE_APP_ENV == 'production'
Vue.prototype.$preprod = process.env.VUE_APP_ENV == 'preprod'

Vue.prototype.$redirectUrl = () => {
  if (Vue.prototype.$production) {
    return `https://${
      Vue.prototype.$slug ? Vue.prototype.$slug + '.' : ''
    }collection-point.collectomate.io/#`
  } else if (Vue.prototype.$preprod) {
    return `https://collection-point.collectomate-preprod.enginearch.com/#`
  } else if (Vue.prototype.$dev) {
    return 'http://localhost:8080/#'
  }
}

Vue.prototype.$format = (date, format) => {
  return date ? window.moment(date).format(format) : null
}

Vue.prototype.$error = errorPayload => {
  toastStore.commit('error', errorPayload)
}

Vue.prototype.$errorHumanized = options => {
  const error = (options || {}).error
  const errorResponse = (error || {}).response
  console.log('error.response', errorResponse)

  const errorCode = ((((error || {}).response || {}).data || {}).errors || {}).flow
  const customMessage = (options || {}).message
  let errorMessage = null
  if (error) {
    errorMessage = Object.values((((error || {}).response || {}).data || {}).errors).join(', ')
  }

  if (customMessage) {
    toastStore.commit('error', { message: customMessage })
  } else if (ERROR_CODES[errorCode]) {
    toastStore.commit('error', { message: i18n.t(`errors.${ERROR_CODES[errorCode]}`) })
  } else if (errorMessage) {
    toastStore.commit('error', { message: errorMessage })
  } else {
    toastStore.commit('error', { message: 'Something went wrong' })
  }
}

Vue.prototype.$confirm = fn => {
  store.commit('modal/open', {
    cmp: ConfirmationModal,
    animation: 'slide-down-menu',
    callback: fn,
  })
}

Vue.prototype.$random = () => {
  return parseInt(Math.random() * 100000000000).toString()
}

Vue.prototype.$slug =
  window.location.hostname != 'localhost' && window.location.host.split('.')[0] != 'pwa'
    ? window.location.host.split('.')[0]
    : ''

Vue.prototype.$isTvn =
  Vue.prototype.$slug == 'tvn' || window.location.host == 'lockery.discovery.com'

Vue.prototype.$isPwc = Vue.prototype.$slug == 'pwc'
Vue.prototype.$isZabka = Vue.prototype.$slug == 'zabka'
Vue.prototype.$isMbank = Vue.prototype.$slug == 'mbank'
Vue.prototype.$isFrontex = Vue.prototype.$slug == 'frontex'
Vue.prototype.$specialRuleProviderSlug = ['pwc', 'zabka', 'tvn']

// microsoftAuthenticationLibrary
if (Vue.prototype.$isZabka) {
  Vue.prototype.$msal = registerMsalInstance()
}

Vue.prototype.$imageHost = () => {
  if (Vue.prototype.$production) {
    return 'https://app.collectomate.io'
  } else if (Vue.prototype.$preprod) {
    return 'https://collectomate-preprod.enginearch.com'
  } else if (Vue.prototype.$dev) {
    return 'http://localhost:3000'
  }
}
